import { observer } from 'mobx-react';
import { Image, ImageFit } from 'office-ui-fabric-react/lib/Image';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import * as React from 'react';
import { CortanaComposeResult } from '../store/schema/CortanaComposeResult';
import { Icon, IIconProps } from 'office-ui-fabric-react/lib/Icon';

const styles = require('./CortanaComposeResultComponent.scss');
const classNames = require('classnames/bind').bind(styles);

export interface CortanComposeResultProps {
    isHighlighted: boolean;
    title: string;
    showSpinner: boolean;
    result: CortanaComposeResult;
    subtitle?: string;
    iconUrl?: string;
    iconStyle?: string;
    iconProps?: IIconProps;
}

const THUMBNAIL_WIDTH = 32;

@observer
export default class CortanaComposeResultComponent extends React.Component<
    CortanComposeResultProps,
    any
> {
    render() {
        const containerClassName = classNames(styles.container, {
            isHighlighted: this.props.isHighlighted,
            isSelectable: this.props.result && this.props.result.selectable,
        });

        return (
            <div
                className={containerClassName}
                onClick={this.onClick}
                key={this.props.title}
                ref={containerDiv => {
                    if (containerDiv && this.props.isHighlighted) {
                        this.scrollIntoViewIfNecessary(containerDiv);
                    }
                }}>
                {!this.props.showSpinner && this.props.iconUrl && (
                    <Image
                        className={styles.iconContainer}
                        src={this.props.iconUrl}
                        imageFit={ImageFit.contain}
                        width={THUMBNAIL_WIDTH}
                        height={THUMBNAIL_WIDTH}
                    />
                )}
                {!this.props.showSpinner && (this.props.iconProps || this.props.iconStyle) && (
                    <div className={styles.iconContainer}>
                        <Icon
                            {...this.props.iconProps}
                            className={classNames([this.props.iconStyle])}
                        />
                    </div>
                )}
                {this.props.showSpinner && (
                    <Spinner className={styles.iconContainer} size={SpinnerSize.medium} />
                )}

                {this.props.subtitle && this.renderTwoRowContent()}
                {!this.props.subtitle && this.renderSingleRowContent()}
            </div>
        );
    }

    private renderSingleRowContent(): JSX.Element {
        return (
            <div className={styles.textContainer}>
                <div className={styles.resultSingleRowTitle}>{this.props.title}</div>
            </div>
        );
    }

    private renderTwoRowContent(): JSX.Element {
        return (
            <div className={styles.textContainer}>
                <div className={styles.resultTitle}>{this.props.title}</div>
                <div className={styles.resultSubtitle}>{this.props.subtitle}</div>
            </div>
        );
    }

    private onClick = () => {
        if (this.props.result && this.props.result.onSelected) {
            this.props.result.onSelected(this.props.result);
        }
    };

    private scrollIntoViewIfNecessary = (element: HTMLElement) => {
        const parent = element.offsetParent.firstElementChild;
        const elementTop = element.offsetTop;
        const elementBottom = elementTop + element.offsetHeight;
        const parentViewportTop = parent.scrollTop;
        const parentViewportBottom = parentViewportTop + parent.clientHeight;

        if (elementTop < parentViewportTop) {
            // case 1: the element is off the top of the viewport
            parent.scrollTop = elementTop;
        } else if (elementBottom > parentViewportBottom) {
            // case 2: the element is off the bottom of the viewport
            parent.scrollTop = elementBottom - parent.clientHeight;
        }
    };
}
